<template>
  <div
    :class="['block-text', sortOrder, {'colored-background': coloredBackground}]"
    :hej="''"
  >
    <div class="text-content">
        <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockText',
  props: ['coloredBackground', 'sortOrder'],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .block-text
    display: flex
    justify-content: center
    align-items: center

    @media only screen and (max-width: 850px)
      min-height: 100%

      &.one
        order: 1

      &.two
        order: 2
      &.three
        order: 3
      &.four
        order: 4
      &.five
        order: 5

    &.colored-background
      background-color: $green30

  .text-content
    max-width: 380px

    p:last-of-type
      margin-bottom: 50px

</style>
